module.exports = __webpack_public_path__ + "img/3-on.8c6078f9.png";